/**
 * شعار المنصة داخل الواجهة. مصدره صورة الهوية الرسمية المشتركة بين الويب وPWA.
 */
export function BrandIcon({
  size = 44,
  className,
}: {
  size?: number;
  className?: string;
}) {
  return (
    <span
      className={`brand-icon${className ? ` ${className}` : ''}`}
      style={{ width: size, height: size }}
      aria-hidden="true"
    >
      <img src="/icons/icon-512.png?v=bed0cd2" alt="" draggable={false} />
    </span>
  );
}
